<div id="custom-breadcrumb" style="z-index: 100">
    <app-current-vendor-description></app-current-vendor-description>
</div>
  